import { Box, Button, Typography } from "@mui/material";
import CriSection from "../../components/CriSection";
import Photo from "../../assets/images/poster.png";

const Poster = () => {
  return (
    <CriSection alternate={true}>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <Box
          sx={{
            marginRight: "36px",
            width: "400px",
          }}
        >
          <img
            src={Photo}
            alt="Poster"
            style={{
              width: "100%",
              height: "300px",
              borderRadius: "12px",
              objectFit: "contain",
            }}
          />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "24px",
                md: "36px",
              },
              fontWeight: 300,
              lineHeight: 1,
            }}
          >
            The Hidden Beauty of the Grasses of the Great Lakes Poster
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 300,
              lineHeight: 1.2,
              marginTop: "12px",
            }}
          >
            Watercolors by Mary Marguerite Lowther from A Call to Beauty. The
            poster is 18" x 28" in size. Gift included with donations over $300
            to Conservation Research Institute.
          </Typography>

          <Button
            variant="contained"
            sx={{
              marginTop: "24px",
              padding: "8px 36px",
            }}
          >
            Buy
          </Button>
        </Box>
      </Box>
    </CriSection>
  );
};

export default Poster;
